import React from 'react';

interface RadioItem {
  id: string;
  label: string;
  checked: boolean;
}

interface Props {
  name: string;
  items: RadioItem[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButtonGroup: React.FunctionComponent<Props> = props => {
  const { name, items, onChange } = props;
  return (
    <div className="btn-group btn-sm">
      {items.map(item => (
        <div className="radio btn" key={item.id}>
          <input
            type="radio"
            name={name}
            id={item.id}
            onChange={onChange}
            checked={item.checked}
          />
          <label htmlFor={item.id}>{item.label}</label>
        </div>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
